import { Injectable, effect, inject } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { locale } from 'moment';
import 'moment/locale/es-us';
import 'moment/locale/pl';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { UserStore } from '@qtek/libs/store';

@Injectable({
  providedIn: 'root',
})
export class QtDateAdapter extends MomentDateAdapter {
  private userStore = inject(UserStore);

  private localeReady: BehaviorSubject<boolean> = new BehaviorSubject(false);

  // tslint:disable member-ordering
  localeReady$: Observable<boolean> = this.localeReady
    .asObservable()
    .pipe(filter<boolean>(Boolean));

  publicLocale: any;

  constructor() {
    const dateLocale = inject(MAT_DATE_LOCALE, { optional: true })!;

    super(dateLocale);

    effect(() => {
      const person = this.userStore.currentPerson();
      if (!person?.language) return;
      const localVar =
        person.language === 'pl_PL'
          ? person.language.slice(0, person.language.indexOf('_'))
          : person.language.replace('_', '-');
      super.setLocale(localVar);
      locale(localVar);
      this.publicLocale = localVar;
      this.localeReady.next(true);
    });
  }
}
